<template>
  <div>
    <div id="page">
      <el-card id="queryForm" :body-style="{padding: '10px 20px 10px 20px'}">
        <el-form :inline="true" size="small" :model="queryForm" ref="queryForm">
          <el-form-item label="用户名：" prop="username">
            <el-input placeholder="用户名模糊查询" v-model="queryForm.username"></el-input>
          </el-form-item>
          <el-form-item label="登录IP：" prop="loginIp">
            <el-input placeholder="登录IP模糊查询" v-model="queryForm.loginIp"></el-input>
          </el-form-item>
          <el-form-item label="时间段：" prop="timeRange">
            <el-date-picker class="date-time-range" v-model="queryForm.timeRange" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" start-placeholder="起始时间" end-placeholder="结束时间" :default-time="['00:00:00', '00:00:00']"></el-date-picker>
            <el-button class="btn-space" type="primary" icon="el-icon-search" @click="search">查询</el-button>
            <el-button type="warning" icon="el-icon-refresh" @click="resetFun('queryForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-table class="table-box" :data="tableData" ref="tableData" @current-change="selectRow" border size="small" stripe height="200" highlight-current-row v-loading="isLoading">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="username" label="用户名" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loginIp" label="登录IP" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loginTime" label="登录时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userAgent" label="浏览器" align="center" width="600" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination :current-page="pager.currentPage" :total="pager.total" :page-sizes="pager.pageSizes" @size-change="sizeChange" @current-change="currentChange" background layout="total, sizes, prev, pager, next, jumper"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginLogList',
  data () {
    return {
      //加载层显示
      isLoading: false,
      //查询参数
      queryForm: {
        username: '',
        loginIp: '',
        timeRange: []
      },
      //分页参数
      pager: {
        currentPage: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100]
      },
      //表格数据
      tableData: [],
      //当前选中行
      currentRow: null
    }
  },
  methods: {
    //每页显示条数改变
    sizeChange: function (size){
      this.pager.pageSize = size
      this.search()
    },
    //当前页改变
    currentChange: function(current){
      this.pager.currentPage = current
      this.search()
    },
    //查询数据
    search: function () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        url: '/sysLoginLog/selectPage',
        data: {
          size: this.pager.pageSize,
          current: this.pager.currentPage,
          orderField: 'id',
          params: [{
            field: 'username',
            type: 'like',
            value: this.queryForm.username
          }, {
            field: 'login_ip',
            type: 'like',
            value: this.queryForm.loginIp
          }, {
            field: 'login_time',
            type: 'ge',
            value: this.queryForm.timeRange[0]
          }, {
            field: 'login_time',
            type: 'le',
            value: this.queryForm.timeRange[1]
          }]
        },
      }).then(response => {
        this.isLoading = false
        this.pager.total = response.total
        this.tableData = response.rows
      }).catch(error => {
        this.isLoading = false
      })
    },
    //重置查询条件
    resetFun: function (formName) {
      this.$refs[formName].resetFields()
      this.search()
    },
    //选中行改变
    selectRow: function (currentRow) {
      this.currentRow = currentRow
    },
  },
  mounted () {
    //加载完成后动态计算表格的高度
    this.$nextTick(() => {
      $('.el-table').css({
        height: $('#page').height() - $('#queryForm').height() - 60
      })
    })
    //查询表格数据
    this.search()
  }
}
</script>

<style scoped>
#page {
  padding: 10px;
  height: calc(100% - 20px);
}

.el-form-item {
  margin-bottom: 10px;
  margin-top: 10px;
}

.el-button-group {
  margin: 8px 0 5px 0;
}

.el-pagination {
  text-align: right;
  padding: 10px;
}

.table-box {
  margin-top: 8px;
}

.date-time-range {
  width: 350px;
}

.btn-space {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/loginLog/LoginLogList.vue